import React from 'react';
import { Button, ButtonGroup, Card, Col, Image, Row } from 'react-bootstrap';
import PageHeading from './shared/PageHeading';
import { Arrow } from 'assets/SVG';
import icon2 from 'assets/icon2.png';
import inter from 'assets/inter.png';
import { Link } from 'react-scroll';

const Interior = () => {
    return (
        <Card className='p-md-4 p-3 rounded-4 border-0 shadow-sm h-100'>
            <Row className="align-items-stretch h-100">
                <Col lg={6} xs={12} className="d-flex flex-column justify-content-between mb-4 mb-lg-0">
                    <div className='my-auto'>
                        <div className="mb-4">
                            <PageHeading image={icon2} color="black" heading={"Innovative Art"} />
                        </div>

                        <p>
                            <strong >With Living Wall,</strong> we guide you to find the perfect digital solution that aligns with the essence of your environment. Whether it’s a welcoming foyer, connecting space, or a public space precinct, Living Wall brings a greater psychological impact that improves connection & productivity.
                        </p>

                        <p>
                            Collaborating with renowned international artists and designers, Living Wall transforms common areas into
                            <strong> state-of-the-art architectural spaces.</strong>
                        </p>

                        <p>Our installations are not mere decorations but conversational pieces that enrich connections and elevate everyday living.</p>

                        <p>
                            <strong>
                                <i>We turn conventional retail spaces into immersive experiences – where technology and creativity unite in multi-faceted, mixed-use environments.</i>
                            </strong>
                        </p>
                    </div>

                    <Col md={5} xs={12}>
                        <ButtonGroup className="d-flex btn-group">
                            <Link
                                to="Connect"
                                smooth={true}
                                duration={500}
                            >
                                <Button className="btn-custom px-4 ">
                                    <small>Learn More</small>
                                </Button>
                            </Link>
                            <span className="arrow">
                                <Arrow />
                            </span>
                        </ButtonGroup>
                    </Col>
                </Col>

                <Col lg={6} xs={12} >
                <div className="h-100">
                    <Image src={inter} alt="Interior Image" className="img-fluid h-100" />
                </div>
                </Col>
            </Row>
        </Card>
    );
};

export default Interior;
